import { useLocalSearchParams } from "expo-router";

import Redirect from "@/components/BreadcrumbRedirect";

export default function UseCaseLanding() {
  const { useCase } = useLocalSearchParams();

  return (
    <Redirect
      href={`/uc/${useCase}`}
      reason="Redirecting from /about to /uc"
      context={{ useCase }}
    />
  );
}
